
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 14.167c-1.395 0-2.61 1.054-3.236 2.609-.3.743.13 1.557.701 1.557h5.069c.57 0 1-.814.7-1.557-.626-1.555-1.84-2.61-3.235-2.61z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M15.417 4.167h1.002c1 0 1.501 0 1.762.314.261.315.153.787-.064 1.73l-.326 1.417c-.49 2.13-2.281 3.713-4.457 4.039M4.583 4.167H3.58c-1 0-1.501 0-1.762.314-.261.315-.153.787.064 1.73l.326 1.417c.49 2.13 2.281 3.713 4.457 4.039","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 14.167c2.518 0 4.638-3.885 5.275-9.175.177-1.462.265-2.194-.202-2.76-.467-.565-1.22-.565-2.728-.565H7.656c-1.507 0-2.26 0-2.728.565-.467.566-.378 1.298-.202 2.76.637 5.29 2.757 9.175 5.275 9.175z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    